// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2r7Dj","footer":"Form_footer__3LvgY"};